import { styled } from '@material-ui/core';
import React from 'react';

import { GestureEvent } from '../../../../../Events/withEvent';
import * as Icons from './ContextIconMenu';
import { I18n } from '../../../../../Locales/I18nService';
import classNames from 'classnames';
import { MOBILE_LIMIT } from 'Web/Context/PlatformContext/PlatformContext';
import { NunitoSansTitle } from 'Web/Components/Widgets/Typographies';
import { HStack } from 'Web/Components/Widgets/Stack';

type MenuItemProps = {
    onClick?: (event?: GestureEvent) => void;
    Icon?: React.ComponentType<React.ComponentProps<'svg'>>;
    title?: React.ReactNode;
    showOnMobile?: boolean;
};

export const Modify = (props: MenuItemProps) => {
    return <BaseMenuItem Icon={Icons.IconModify} title={I18n.get('MapContextMenu_Modify')} {...props} />;
};

export const Move = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconMove} title={I18n.get('MapContextMenu_Move')} />;
};

export const Duplicate = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconDuplicate} title={I18n.get('MapContextMenu_Duplicate')} />;
};

export const Rotate90H = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconRotate90H} title={I18n.get('MapContextMenu_Rotate_AntiHoraire')} />;
};

export const Rotate90AntiH = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconRotate90AntiH} title={I18n.get('MapContextMenu_Rotate_Horaire')} />;
};

export const AddOpening = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconAddOpenig} title={I18n.get('MapContextMenu_Add')} />;
};

export const DivideWall = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconDivideWall} title={I18n.get('MapContextMenu_DivideWall')} />;
};

export const Delete = (props: MenuItemProps) => {
    return <BaseMenuItem {...props} Icon={Icons.IconDelete} title={I18n.get('MapContextMenu_Delete')} />;
};

//#region //* BASE LIST ITEM

const BaseMenuItem = ({ onClick, Icon, title, showOnMobile }: MenuItemProps) => {
    const classname = classNames({ showOnMobile });
    return (
        <Container onClick={onClick} onTouchStart={onClick} className={classname}>
            {Icon && <Icon style={{ width: 42 }} />}
            <Title className="title">{title}</Title>
        </Container>
    );
};

const Container = styled(HStack)({
    cursor: 'pointer',
    height: 42,
    color: '#000000',
    '@media (hover)': {
        '&:hover': {
            background: '#13123A',
            stroke: '#FFFFFF',
            fill: '#FFFFFF',
            '& .title': { color: '#FFFFFF' },
            '& .overrideFillColor': { fill: '#FFFFFF' },
            '& .overrideStrokeColor': { stroke: '#FFFFFF' },
        },
    },
    '&.showOnMobile': {
        display: 'none',
        [`@media (max-width: ${MOBILE_LIMIT.WIDTH_900}px)`]: { display: 'flex' },
    },
});

const Title = styled(NunitoSansTitle)({ fontSize: 14, lineHeight: '14px' });

export const Divider = styled('div')({
    margin: '0px 9px',
    borderTop: '1px solid #EFEFEF',
    '&.showOnMobile': {
        display: 'none',
        [`@media (max-width: ${MOBILE_LIMIT.WIDTH_900}px)`]: { display: 'flex' },
    },
});

//#endregion

export const ContextMenuItem = {
    Modify,
    Move,
    Duplicate,
    Rotate90H,
    Rotate90AntiH,
    AddOpening,
    DivideWall,
    Delete,
    Divider,
};
